export default __webpack_public_path__ + "static/media/csv-planilhas-icon.98e93b78.svg";